import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {Period} from "../../models/period.model";
import {PeriodService} from "../../services/period.service";

@Component({
  selector: 'app-select-period',
  templateUrl: './select-period.component.html',
  styleUrls: ['./select-period.component.css']
})
export class SelectPeriodComponent implements OnInit, OnChanges {

  heading = 'Period Select';
  periodValue: Period | undefined;
  periods: Period[] = [];
  loading: boolean;

  @Output()
  periodChanged = new EventEmitter<Period>();

  @Input()
  all = false;

  @Input()
  period_id = null;

  @Input()
  isDisable = false;

  constructor(private periodService: PeriodService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.loading = true;
    this.periodService.getPeriods()
      .subscribe((response: Period) => {
        // @ts-ignore
        if (response['error'] === 0) {
          // @ts-ignore
          this.periods = response['result']['data'].slice();

          if (this.period_id) {
            this.periodValue = this.periods.find(i => i.period_id === this.period_id);
            console.log(this.periodValue);
          }
          this.loading = false;
        } else {
          this.loading = false;
          // @ts-ignore
          this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
        }
      }, (error: any) => {
        this.loading = false;
        this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
      });
  }
   ngOnChanges(changes: any): void {
    if (!this.period_id) {
      if (this.all) {
        // @ts-ignore
        this.periodChanged.emit(null);
        return;
      }
    }
    if (this.period_id) {
      this.periodValue = this.periods.find(i => i.period_id === this.period_id);
      console.log(this.periodValue);
    }
  }

  onChange(item:any) {

    if (!item) {
      // @ts-ignore
      this.periodChanged.emit(null);
      return;
    }

    this.periodChanged.emit(this.periodValue);
  }

}
